import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BaseModal } from "@app/shared/cerrix-modal/BaseModal";
import { DataStructureModel } from "@app/datamanagement/models/DataStructureModel";
import { CerrixTextfieldComponent } from "@app/shared/components/cerrix-textinput/cerrix-textfield/cerrix-textfield.component";

@Component({
    selector: "archivepolicy-dialog",
    templateUrl: "./archivepolicy-dialog.component.html",
    styleUrls: ["./archivepolicy-dialog.component.scss", "../../../../sass/datamanagement.scss"],
    imports: [FormsModule, CerrixTextfieldComponent],
})
export class ArchivePolicyDialogComponent extends BaseModal {
    dataStructures: DataStructureModel[];
    disabled: boolean;

    // Base modal implementation
    okClick() {
        this._bsModalRef.hide();

        super.onConfirm(this.dataStructures);
    }

    closeClick() {
        super.onCancel();
    }
}
